import {
    ApiParameter,
    get,
    HasPagingParameters,
    patch,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import {
    PunchoutIdentityCollectionModel,
    PunchoutUserIdentityCollectionModel,
    UserIdentity,
    UserIdentityModel,
} from "@TKCCP/Types/ApiModels";

export interface GetPunchoutIdentityApiParameter extends ApiParameter, HasPagingParameters {
    sort?: string;
    query?: string;
    expand?: "top3products"[];
    additionalExpands?: string[];
    filter?: string;
    identitySearchOperator?: string;
    identitySearch?: string;
}
export interface GetPunchoutUserIdentityApiParameter extends ApiParameter, HasPagingParameters {
    userId: string;
}

export interface UserIdentityApiParameter extends ApiParameter {
    userIdentityList: UserIdentityModel[] | null;
}

const identityCollectionUrl = "/api/v1/punchoutidentity";

export async function getPunchoutIdentityCollection(
    parameter: GetPunchoutIdentityApiParameter,
): Promise<PunchoutIdentityCollectionModel> {
    const identites = await get<PunchoutIdentityCollectionModel>(`${identityCollectionUrl}/all`, parameter);
    return identites;
}

export async function getUserIdentity(
    parameter: GetPunchoutUserIdentityApiParameter,
): Promise<PunchoutUserIdentityCollectionModel> {
    const userid = parameter.userId;
    const result = await get<PunchoutUserIdentityCollectionModel>(`${identityCollectionUrl}/${userid}`);
    return result;
}

export async function createUpdateIdentity(parameter: UserIdentityApiParameter) {
    const result = await post<UserIdentityApiParameter, UserIdentity>(
        `${identityCollectionUrl}/saveuseridentity`,
        parameter,
    );
    return result.status;
}
